import { Inject, Injectable } from '@angular/core';
import { Actions } from '@ngrx/effects';
import * as ObjectActions from './home.actions';
import { HttpClient } from '@angular/common/http';
import { Store } from '@ngrx/store';
import { IotDeviceManagementPortalAppState } from '../iotDeviceManagementPortalApp.reducer';


@Injectable()
export class HomeEffects {

  constructor(
    private actions$: Actions<ObjectActions.HomeActions>,
    private http: HttpClient,
    private store: Store<IotDeviceManagementPortalAppState>,
    @Inject('API_BASE_URL') private readonly baseUrl: string,
  ) {}

  private HOME_URLS = {
    GET: {
      GET_HOME_INFORMATION: `${this.baseUrl}/lines/:lineId/get-home-information`,
      HEART_BEAT: '/api/heartbeat',
      GET_QUANTITY_FROM_SENSOR: 'lines/:id/quantities',
      GET_ACTIVITY_TREE_GRAPH: '/api/get-activity-tree-graph',
      GENERATE_AUTH_KEY_AND_GRANT: '/api/generate-auth-key-and-grant',
      GET_CHECK_IN_LIST: '/api/check-in-list',
      SEARCH_TASK_BY_ACTIVITY_ID: '/api/tasks/all',
      GET_WORK_ORDER: `${this.baseUrl}/work-orders`,
      GET_VERSION_DETAIL: `${this.baseUrl}/product-versions`,
      GET_PRODUCT_PERFORMANCE: '/product-performance',
      GET_PRODUCT_VERSION: `${this.baseUrl}/product-versions`,
      PRODUCT_SEARCH: `${this.baseUrl}/products`,
      GET_WORK_ORDER_NUMBERS: `${this.baseUrl}/work-orders`,
      SEARCH_USERS_BY_FILTER: '/api/authorized-users',
    },
    POST: {
      SAVE_WORK_ORDER_FEEDBACK: `${this.baseUrl}/work-order-close-feedbacks`,
      UPDATE_GOOD_AND_SCRAP: `${this.baseUrl}/work-orders/update-good-and-scrap`,
      CHANGE_ACTIVITY: 'activity-histories/change-activity',
      UPDATE_FINALIZER_SWITCH: '/api/updatefinalizerswitch',
      UPDATE_CURRENT_ACTIVITY:
        // tslint:disable-next-line:max-line-length
        'lines/:id/activity?join=currentActivity&join=currentActivity.activitySubType&join=currentTask&join=currentWorkOrder&join=currentWorkOrder.product&join=currentWorkOrder.product.productSpeedTable&join=currentWorkOrder.productVersionInfo',
    },
    PATCH: {
      UPDATE_WORK_ORDER: `${this.baseUrl}/work-orders/update-work-order-status`,
    },
  };

}
